/* Buffalo Blanks — koleksiyon kartı renk swatch'ları + tek H1.
   Yalnız collection.blanks şablonunda yüklenir (buffalo-blanks-colnav).

   NEDEN VERİ ADACIĞI: Refresh'in snippets/card-product.liquid dosyası TÜM vitrinde
   (koleksiyon, arama, ilgili ürünler) kullanılıyor; onu çatallamak mağaza genelinde risk.
   Onun yerine colnav bir <script type="application/json"> adacığı basar, burada
   kartlara enjekte edilir. Kart kimliği: a[id^="CardLink-"] -> son parça = product id.

   ⚠ KAPSAM: adacık koleksiyonun İLK sayfasındaki ürünleri taşır (Liquid'de bölüm
   dışından paginate'e erişilemez). 2. sayfa ve sonrasında swatch ÇİZİLMEZ — kart
   normal görünür, hata olmaz. Tam kapsam card-product.liquid çatallamayı gerektirir. */
(function () {
  if (window.__bbcInit) { return; }
  window.__bbcInit = true;

  function veri() {
    var el = document.getElementById('bbcColors');
    if (!el) { return null; }
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function urunId(kart) {
    var a = kart.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
    if (!a) { return null; }
    var p = a.id.split('-');
    return p[p.length - 1] || null;
  }

  function gorselDegistir(kart, btn) {
    var img = kart.querySelector('.card__media img, .card__inner img');
    var src = btn.getAttribute('data-img');
    if (!img || !src) { return; }
    img.setAttribute('src', src);
    var ss = btn.getAttribute('data-srcset');
    if (ss) { img.setAttribute('srcset', ss); } else { img.removeAttribute('srcset'); }
    var vid = btn.getAttribute('data-vid');
    if (vid) {
      kart.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.href = a.href.split('?')[0] + '?variant=' + vid;
      });
    }
  }

  function ciz(kart, renkler) {
    if (!renkler || !renkler.length || kart.querySelector('.bbc-swrow')) { return; }
    var ul = document.createElement('ul');
    ul.className = 'bbc-swrow';
    renkler.slice(0, 8).forEach(function (c, i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bbc-sw' + (i === 0 ? ' is-on' : '');
      b.title = c.n || '';
      b.setAttribute('aria-label', c.n || 'color');
      if (c.h) {
        b.style.background = c.h;
        if (c.h2) { b.style.backgroundImage = 'linear-gradient(135deg,' + c.h + ' 50%,' + c.h2 + ' 50%)'; }
      } else if (c.sw) {
        var im = document.createElement('img');
        im.src = c.sw; im.alt = ''; im.loading = 'lazy'; b.appendChild(im);
      }
      if (c.img) { b.setAttribute('data-img', c.img); }
      if (c.ss) { b.setAttribute('data-srcset', c.ss); }
      if (c.v) { b.setAttribute('data-vid', c.v); }
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ul.querySelectorAll('.bbc-sw.is-on').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        gorselDegistir(kart, b);
      });
      li.appendChild(b); ul.appendChild(li);
    });
    if (renkler.length > 8) {
      var li2 = document.createElement('li');
      var s = document.createElement('span');
      s.className = 'bbc-more';
      s.textContent = '+' + (renkler.length - 8);
      li2.appendChild(s); ul.appendChild(li2);
    }
    var hedef = kart.querySelector('.card__information') || kart.querySelector('.card__content');
    if (hedef) { hedef.appendChild(ul); }
  }

  function calistir() {
    var d = veri();
    if (!d) { return; }
    document.querySelectorAll('.card-wrapper').forEach(function (kart) {
      var id = urunId(kart);
      if (id && d[id]) { ciz(kart, d[id]); }
    });
  }

  function tekH1() {
    /* Hero'daki H1 varsa temanın koleksiyon başlığını DOM'dan kaldır (iki H1 SEO hatası). */
    if (!document.querySelector('.bch h1')) { return; }
    document.body.classList.add('bbc-single-h1');
    document.querySelectorAll('.collection-hero__title, .main-collection-banner h1').forEach(function (h) {
      if (h.closest('.bch')) { return; }
      h.remove();
    });
  }

  function baslat() { tekH1(); calistir(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else { baslat(); }
  /* Refresh filtre/sıralama sonrası ızgarayı yeniden çizer -> yeniden enjekte et. */
  document.addEventListener('shopify:section:load', calistir);
  new MutationObserver(function () { calistir(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
